import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Text } from "../../components/Text";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { useDispatch, useSelector } from "react-redux";
import { addOfficeNote, getOfficeNotes } from "../../reducers/officenoteSlice";
import { CustomButton } from "../../components/CustomButton";
import { useLayout } from "../../context/LayoutContext";
import * as Messag from "../../config/ToastMessage";
import Loader from "../../components/Loader";

const QuickNotes = () => {
  const { toast } = useLayout();
  const [loading,setLoading] = useState(false)
  const dispatch = useDispatch();
  const [generic, setGeneric] = useState("");
  const [isCheckedGeneric, setIsCheckedGeneric] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [weekends, setWeekends] = useState("");
  const [isCheckedWeekends, setIsCheckedWeekends] = useState(false);
  const [isDisableWeekends, setIsDisableWeekends] = useState(true);
  const [seasonal, setSeasonal] = useState("");
  const [isCheckedSeasonal, setIsCheckedSeasonal] = useState(false);
  const [isDisableSeasonal, setIsDisableSeasonal] = useState(true);
  const officeNote = useSelector(
    (state) => state?.officeNote?.officeNotes?.data
  );

  useEffect(() => {
    dispatch(getOfficeNotes());
  }, [dispatch]);

  useEffect(() => {
    // If officeNote is available, set the state accordingly
    if (officeNote && officeNote.length > 0) {
      const genericNote = officeNote.find(
        (note) => note.title === "Generic Out-of-Office"
      );
      const weekendsNote = officeNote.find(
        (note) => note.title === "Weekend Hours"
      );
      const seasonalNote = officeNote.find(
        (note) => note.title === "After Hours"
      );

      if (genericNote) {
        setGeneric(genericNote.notes || "");
        setIsCheckedGeneric(genericNote.isEnable);
      }

      if (weekendsNote) {
        setWeekends(weekendsNote.notes || "");
        setIsCheckedWeekends(weekendsNote.isEnable);
      }

      if (seasonalNote) {
        setSeasonal(seasonalNote.notes || "");
        setIsCheckedSeasonal(seasonalNote.isEnable);
      }
    }
  }, [officeNote]);

  const handleSave = () => {
    setLoading(true)
    const data = [
      {
        notes: generic,
        title: "Generic Out-of-Office",
        isEnable: isCheckedGeneric,
      },
      {
        notes: weekends,
        title: "Weekend Hours",
        isEnable: isCheckedWeekends,
      },
      {
        notes: seasonal,
        title: "After Hours",
        isEnable: isCheckedSeasonal,
      },
    ];
    let officeNote = {
      notesData: data,
    };
    dispatch(addOfficeNote(officeNote))
      .unwrap()
      .then((res) => {
        let Message_Success = Messag.Add_office_ToastSuccessMessage;
        toast.current.show({
          severity: "success",
          detail: Message_Success,
        });
        dispatch(getOfficeNotes());
        setIsCheckedGeneric(true)
        setIsCheckedSeasonal(true)
        setIsCheckedWeekends(true)
        setLoading(false)
      })
      .catch((err) => {
        toast.current.show({ severity: "error", detail: err.response.data });
        setLoading(false)
      });
    // console.log(officeNote);
  };

  return (
    <div>
      <Card className="px-3 relative flex">
        <Loader visible={loading}/>
        <div className="flex justify-between items-center">
          <div className="flex">
            <Checkbox
              name="checkbox"
              checked={isCheckedGeneric}
              onChange={(e) => setIsCheckedGeneric(e?.target?.checked)}
              disabled={isDisable}
            />
            <div className="px-3">
              <Text type={"heading"}>{"Generic Out-of-Office"}</Text>
              <div className="mt-2" style={{ width: "73vw" }}>
                <InputTextarea
                  rows={2}
                  className={`w-full ${
                    isDisable ? "bg-gray-200" : ""
                  } font-bold`}
                  value={generic}
                  onChange={(e) => setGeneric(e?.target.value)}
                  disabled={isDisable}
                />
              </div>
            </div>
          </div>
          <div className="p-d-flex p-ai-center p-jc-start col-1 mt-3">
            <Button
              icon={isDisable ? "pi pi-pencil" : 'pi pi-ban'}
              className="p-button-text dark-icon p-mr-2 card_icon" 
              aria-label="Edit"
              onClick={() => setIsDisable(!isDisable)}
            />
          </div>
        </div>
      </Card>

      {/* Weekends Section */}
      <Card className="px-3 relative flex mt-2">
        <div className="flex justify-between items-center">
          <div className="flex">
            <Checkbox
              name="checkbox"
              checked={isCheckedWeekends}
              onChange={(e) => setIsCheckedWeekends(e?.target?.checked)}
              disabled={isDisableWeekends}
            />
            <div className="px-3">
              <Text type={"heading"}>{"Weekends"}</Text>
              <div className="mt-2" style={{ width: "73vw" }}>
                <InputTextarea
                  rows={2}
                  className={`w-full ${
                    isDisableWeekends ? "bg-gray-200" : ""
                  } font-bold`} // Apply grey background if disabled
                  value={weekends}
                  onChange={(e) => setWeekends(e?.target.value)}
                  disabled={isDisableWeekends}
                />
              </div>
            </div>
          </div>
          <div className="p-d-flex p-ai-center p-jc-start col-1 mt-3">
            <Button
              icon={isDisableWeekends ? "pi pi-pencil" : "pi pi-ban"}
              className="p-button-text dark-icon p-mr-2 card_icon"
              aria-label="Edit"
              onClick={() => setIsDisableWeekends(!isDisableWeekends)}
            />
          </div>
        </div>
      </Card>

      {/* Seasonal Message Section */}
      <Card className="px-3 relative flex mt-2">
        <div className="flex justify-between items-center">
          <div className="flex">
            <Checkbox
              name="checkbox"
              checked={isCheckedSeasonal}
              onChange={(e) => setIsCheckedSeasonal(e?.target?.checked)}
              disabled={isDisableSeasonal}
            />
            <div className="px-3">
              <Text type={"heading"}>{"Seasonal Message"}</Text>
              <div className="mt-2" style={{ width: "73vw" }}>
                <InputTextarea
                  rows={2}
                  className={`w-full ${
                    isDisableSeasonal ? "bg-gray-200" : ""
                  } font-bold`}
                  value={seasonal}
                  onChange={(e) => setSeasonal(e?.target.value)}
                  disabled={isDisableSeasonal}
                />
              </div>
            </div>
          </div>
          <div className="p-d-flex p-ai-center p-jc-start col-1 mt-3">
            <Button
              icon={isDisableSeasonal ? `pi pi-pencil` : `pi pi-ban`}
              className="p-button-text dark-icon p-mr-2 card_icon"
              aria-label="Edit"
              onClick={() => setIsDisableSeasonal(!isDisableSeasonal)}
            />
          </div>
        </div>
      </Card>

      <div className="flex gap-2 justify-content-end align-items-center flex-grow-1 mt-2">
        <div className="flex gap-2">
          <CustomButton varient="filled" label={"Save"} onClick={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default QuickNotes;
